module.exports = __webpack_public_path__ + "img/heybirdie.co.kr_.3eb01dd.webp";